import { reducer } from './knowledge-checks-redux'

export { reducer as knowledgeChecksReducer }
